var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBigIWarning = function SvgBigIWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fixed",
    id: "_\\u043B\\u043E\\u0439_1",
    "data-name": "\\u2018\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 2000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 3000,
    height: 2000,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2573.27,1840.87c-148.19,0-2151.67-4.32-2151.67-4.56-.82-2-254.33-312.65,64.89-637.5,158.17-161-145.25-369.5,0-548.54,248.8-306.7,495-134,700.07-220.23,36.24-15.22,72.6-39.73,109-77.34a405.66,405.66,0,0,1,67-55.61q5.54-3.69,11.17-7.19a448.8,448.8,0,0,1,44.69-24.25q15.49-7.31,31.57-13.51h0a514.54,514.54,0,0,1,52.31-17,592.32,592.32,0,0,1,78-15.3q17.4-2.27,35.08-3.58c229.16-17.23,487,79.67,620.13,221.3,26.79,28.52,148.63,176.08,52.59,378.91-60.64,128.06,193.39,250.36,283.67,396.59C2801.28,1584.81,2575.35,1836,2573.27,1840.87Z",
    style: {
      fill: "#d0e4fa",
      opacity: 0.47000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.77,1837.14h101.6c5.45-4.62-3.77-15.11-13.39-15.81-4.18-.32-9.47.56-15.51,1.83-1.4-18.57-9.38-102-39.47-98.69-33.83,3.76,0,36.76,9.56,56.3,7.09,14.48,14.56,35.23,18,45-2.75.6-5.59,1.18-8.5,1.71-4.48-13.76-21.17-60.08-42.39-57.38-24.91,3.16-14.89,21.73,2.76,32.75,13,8.11,28.87,19.63,36.43,25.19a107.41,107.41,0,0,1-19.87,1.59C499.56,1829.25,491.07,1834.38,487.77,1837.14Z",
    style: {
      fill: "#56cc91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2104.67,1837.14h-94.36c-5.06-4.29,3.5-14,12.44-14.69,3.88-.29,8.79.52,14.4,1.71,1.3-17.25,8.71-94.79,36.66-91.67,31.43,3.49,0,34.14-8.88,52.3-6.58,13.44-13.52,32.72-16.7,41.82,2.56.55,5.2,1.09,7.89,1.59,4.17-12.79,19.67-55.81,39.38-53.3,23.14,2.93,13.84,20.18-2.56,30.42-12,7.53-26.81,18.23-33.83,23.4a100.79,100.79,0,0,0,18.45,1.48C2093.73,1829.81,2101.62,1834.58,2104.67,1837.14Z",
    style: {
      fill: "#56cc91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2172.07,1218.56s2.25-22.34-9.44-21.58-14.77,6.13-13.47,10.42,12.67,18.5,12.67,18.5Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354.1,1263.32s-12.94,15.2-40.75,32.73q-3.95,2.51-8.29,5a308.75,308.75,0,0,1-38.1,18.75c-1.61.66-3.5,1.39-5.63,2.15-16.66,6-47.33,14.55-66.33,15.32-1.66.06-3.22.06-4.68,0-28.93-1.17-32.45-113.43-32.45-113.43s3.22-11.23,18.08-8.4c0,0,22.56,63.39,30.65,68.56,7.19,4.6,48.47-58,84-62.37C2314.54,1218.73,2354.1,1263.32,2354.1,1263.32Z",
    style: {
      fill: "#2094f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2276.39,1810.74s2.14,24.71-3.08,27.28l-66.85-.13s0-7.72,10.73-9.43,29.6-8,32.8-22S2276.39,1810.74,2276.39,1810.74Z",
    style: {
      fill: "#1c3154"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2227.32,1511.66c.33,16.16,1.1,32.82,2.62,47.8,7.22,71.08,9.76,157,10.8,173.52,1.8,28.74,7.47,74.66,7.47,74.66s11.27,10.69,33.22,5.59c0,0,18.19-66.14,22.25-135.77l.18-3.44c.47-9.21,1-19.74,1.47-31.09,3.35-76,7-189,7-189l-83.89-19.7S2226.49,1471.37,2227.32,1511.66Z",
    style: {
      fill: "#15345b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2227.32,1511.66c21.26,36.68,61.78,104.25,78,131.27,3.35-76,7-189,7-189l-83.89-19.7S2226.49,1471.37,2227.32,1511.66Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2261.33,1322c-16.66,6-47.33,14.55-66.33,15.32,2.9-.55,24.06-4.74,31.89-14.19,8.4-10.15,22.56-37.74,33.81-26.48C2266,1301.93,2264.45,1312.4,2261.33,1322Z",
    style: {
      fill: "#6385db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2402.29,1499.71s5.21,20.42,4.35,25-5.93,19.91-9.1,23.72-3.3-16.57-5.41-19.77-1,7.61-2.66,8.49-4.5-8.19-5.76-11.41,4.51-14.41,5-22.44S2402.29,1499.71,2402.29,1499.71Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2442.92,1782.66s11.9,10.85,9.58,18.57-13.06,12.86-14.51,22.29-7.25,14.57-12.48,14.57h-24.9s-3.85-6.63,5.44-8.63,12.79-13.09,12.21-23.37.87-24,.87-24l19.73-4.57Z",
    style: {
      fill: "#1c3154"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2241.64,1455.67s78.53,168,120.32,241.74,54.85,94.3,54.85,94.3,23.94-9.43,26.11-15.86c0,0-16-142.33-44-177-15.82-19.61-34.39-78.44-35.26-99s-19.22-69.68-19.22-69.68Z",
    style: {
      fill: "#15345b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2227,1446.93s25.57,27.52,69,35.83c19.07,3.65,57.78,7.17,67.38-6.4,2.25-3.19,2.27-7.91,1.77-15.28-1.29-19.15-6.11-56.18,15.64-130.59a126.16,126.16,0,0,0,4.18-19.89c4.75-38.06,4.24-66.8-28.79-82.15-49.49-23-69.8-4.08-69.8-4.08s-26.32,12.3-38.34,48.14C2224,1344.21,2227,1446.93,2227,1446.93Z",
    style: {
      fill: "#2094f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2326.5,1222.13a36.72,36.72,0,0,1-37,2.42c-1.08-.54-.95-7.93-.68-15.19s.94-14.11.94-14.11l17.61-11.56,16.8-11C2322.2,1210.57,2330.26,1219.44,2326.5,1222.13Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2321.26,1188.31s-11.43,17.15-32.4,21c.27-7.12,1-15,1-15l17.52-10.7Z",
    style: {
      fill: "#ed985f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2274,1190.79s42.6,15.9,52.08-10.35,21.36-41.87-5.44-53.13-35.72-3.14-41.05,4.85S2263.2,1186,2274,1190.79Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2352.65,1130.26c.49-.38,1.48-.57,3.56-.27a8.52,8.52,0,0,0-3.62-1.84c.13-2.94-.39-8.29-5.05-10.48a6.23,6.23,0,0,1,2.1,5c-4.53-7-15.87-13.62-50.14-17.62-45.15-5.27-36.12,26.09-31,30.62s21.41-1.91,32,1.06,9.54,18.87,12.76,21.72,2.53-1.2,7.89-2.45,4.22,7,1.75,12,2.91,13.35,2.91,13.35l8.29-6c8.29-6,20.89-35.92,19.09-43.18C2353,1131.56,2352.81,1130.91,2352.65,1130.26Z",
    style: {
      fill: "#2c3a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365.18,1461.08c-1.29-19.15-6.11-56.18,15.64-130.59a126.16,126.16,0,0,0,4.18-19.89h0c-16.16-5.33-45.61,6.53-45.61,6.53S2332.47,1415.49,2365.18,1461.08Z",
    style: {
      fill: "#6385db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365.12,1233.43s19.88,7.23,32.57,59.87c8.38,34.79,23.8,85.91,25.54,102s-17.63,110.13-17.63,110.13-2.74,2-9.43.65a15.55,15.55,0,0,1-9.39-5.61s-4.64-62.7-3.44-92.3c.5-12.3-56.93-90.07-87.93-100.09C2283.24,1304.13,2365.12,1233.43,2365.12,1233.43Z",
    style: {
      fill: "#2094f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2087,1165.28s57.47-1.64,123.8,10.57l6.92-17.46,7.6-19.13s-66.58-28.66-106.6-68.58Z",
    style: {
      fill: "#aec3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2119.62,1069.75l-33,97.41h0a8.79,8.79,0,0,1-5.78-11.36l29-81.84a7.25,7.25,0,0,1,9.74-4.21Z",
    style: {
      fill: "#fcbf53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2151.12,1237.77h0a11.91,11.91,0,0,0,14-9.33l11.36-56.85a11.91,11.91,0,0,0-9.33-14h0a11.94,11.94,0,0,0-14,9.33l-11.36,56.85A11.93,11.93,0,0,0,2151.12,1237.77Z",
    style: {
      fill: "#fcbf53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2087,1165.28s57.47-1.64,123.8,10.57l6.92-17.46C2155.4,1145.67,2087,1165.28,2087,1165.28Z",
    style: {
      fill: "#739af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2192.45,1172.34l18,3.16c-.28,0,16.68,3.3,22.24-11.73a12.2,12.2,0,0,0,1.06-3.24c4.32-18.73-6-22.18-6-22.18l-23.12-9-7.34,26v.09Z",
    style: {
      fill: "#fcbf53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2192.45,1172.34l18,3.16c-.28,0,16.68,3.3,22.24-11.73-10.16-7.39-35.36-8.44-35.36-8.44v.09Z",
    style: {
      fill: "#ed7d2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.65,1182.73s8.78,3.5,7.17,7.37-12.78,9.18-14.54,6.13S2147.12,1179.46,2152.65,1182.73Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2172.24,1215a122.87,122.87,0,0,0,1.76-13.12c.1-4.13.59-7.5-.38-7.62s-1.68.65-2.08,2-1.92,9.56-1.92,9.56l.77,7.94Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.31,1209.17,1253.54,1801s-5.21,35.88,21.47,35.94c43.87.11,218.38,0,218.38,0s-33-7.47-32.63-24.27c.48-19.8,58.18-609.07,58.18-609.07Z",
    style: {
      fill: "#0067c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.81,1826.41c-8.63,0-177.57.31-220.29-.24-18.62-.23-21.89-16.55-22-27.12a53,53,0,0,1,.56-8.81l1.3-15.38,3.3-39.2,2.91-34.64,3.74-44.51,3.16-37.56,35.36-420.52,215.63-5.6S1509.14,1439.44,1492,1619c-1.92,20-3.75,39.17-5.43,57.08q-.82,8.57-1.59,16.74c-1.59,17-3,32.58-4.32,46.35-.67,7.26-1.28,14-1.84,20.18-2.19,24.21-3.48,39.67-3.5,42.61a25,25,0,0,0,.42,4.79C1479.23,1825.56,1506.57,1826.41,1509.81,1826.41Z",
    style: {
      fill: "#2094f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "779.65 887.13 900.89 1374.12 917.49 1440.81 973.95 1667.63 2023 1667.63 1814.88 887.13 779.65 887.13",
    style: {
      fill: "#2094f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "779.65 887.13 762.85 892.73 951.62 1684.57 973.96 1667.63 779.65 887.13",
    style: {
      fill: "#0c81e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "951.62 1684.57 1994.21 1684.57 2023 1667.63 973.96 1667.63 951.62 1684.57",
    style: {
      fill: "#0c81e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1317.74,
    y: 1826.41,
    width: 225.74,
    height: 10.73,
    transform: "translate(2861.22 3663.55) rotate(180)",
    style: {
      fill: "#0067c0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1486.1 1684.57 1484.93 1692.77 1272.64 1735.66 1275.55 1701.02 1276.94 1684.57 1486.1 1684.57",
    style: {
      fill: "#0c81e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.81,1826.41c-8.63,0-177.57.31-220.29-.24-18.62-.23-21.89-16.55-22-27.12l211.29-39.75c-2.19,24.21-3.48,39.67-3.5,42.61a25,25,0,0,0,.42,4.79C1479.23,1825.56,1506.57,1826.41,1509.81,1826.41Z",
    style: {
      fill: "#6ec4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "779.65 887.13 1814.88 887.13 1982.84 1514.41 935.81 1514.41 779.65 887.13",
    style: {
      fill: "#0c81e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1934.02 1487.22 964.73 1487.22 930.09 1349.24 916.69 1295.85 911.23 1274.08 875.63 1132.28 873.78 1124.9 854.97 1049.94 846.55 1016.41 839.37 987.8 822.53 920.74 1777.84 920.74 1796.33 987.8 1804.22 1016.41 1813.46 1049.94 1874.37 1270.89 1874.37 1270.9 1879.53 1289.62 1881.93 1298.31 1923.99 1450.84 1934.02 1487.22",
    style: {
      fill: "#6ec4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1796.34 987.8 839.37 987.8 822.53 920.73 1777.85 920.73 1796.34 987.8",
    style: {
      fill: "#0c81e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.05,951c-1.15-4.63,1.67-8.38,6.3-8.38A11.44,11.44,0,0,1,878.82,951c1.16,4.63-1.66,8.39-6.29,8.39A11.47,11.47,0,0,1,862.05,951Z",
    style: {
      fill: "#e9f3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.91,951c-1.15-4.63,1.67-8.38,6.3-8.38A11.44,11.44,0,0,1,906.68,951c1.15,4.63-1.66,8.39-6.29,8.39A11.47,11.47,0,0,1,889.91,951Z",
    style: {
      fill: "#e9f3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.91,951c-1.16-4.63,1.66-8.38,6.29-8.38A11.46,11.46,0,0,1,936.68,951c1.15,4.63-1.67,8.39-6.3,8.39A11.45,11.45,0,0,1,919.91,951Z",
    style: {
      fill: "#e9f3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1976.36,1500.58l-842.24,71c-63.95,5.39-110.23-59.8-84-118.4L1406.9,654.56C1434,594,1517.18,587,1554,642.17l485.41,727.61C2075,1423.17,2040.31,1495.19,1976.36,1500.58Z",
    style: {
      fill: "#e6efff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979,1532.43l-842.23,71a116.27,116.27,0,0,1-115.92-163.3l356.82-798.57c17.53-39.24,53.57-64.83,96.4-68.43s82.64,15.58,106.49,51.33L2066,1352a116.28,116.28,0,0,1-87,180.39ZM1479.48,636.8a51.68,51.68,0,0,0-43.39,30.8l-356.83,798.58a52.34,52.34,0,0,0,52.18,73.5l842.23-71a52.35,52.35,0,0,0,39.15-81.2L1527.41,659.91A51.7,51.7,0,0,0,1479.48,636.8Z",
    style: {
      fill: "#fcbf53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1459.74,1378.4a77.19,77.19,0,0,1,3.28-30.59,70.62,70.62,0,0,1,14.41-25.31,75.69,75.69,0,0,1,24.2-17.94q14.43-6.91,33.14-8.51a96.63,96.63,0,0,1,34.34,2.82,75.34,75.34,0,0,1,27.11,13.62,70.75,70.75,0,0,1,18.45,22.55,77.35,77.35,0,0,1,8.35,29.6,75.39,75.39,0,0,1-3.3,30.34,71.31,71.31,0,0,1-14.43,25.07,75,75,0,0,1-24.46,18,96.46,96.46,0,0,1-33.38,8.53q-18.72,1.57-34.1-2.84a75.4,75.4,0,0,1-26.85-13.64,70.88,70.88,0,0,1-18.43-22.3A75.36,75.36,0,0,1,1459.74,1378.4ZM1590,1226l-121.32,10.22-52.11-413.07,155.69-13.12Z",
    style: {
      fill: "#fcbf53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.75,1251.36s2.64-5.94,4.35-8.75,9-11,10.26-9.18,6.22,14.42,3.58,17.93.17,9.64-13,13.34Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.68,1213.86s67.28,56.17,93.52,51c20.52-4.07,52.95-14.36,52.95-14.36s8.56,8.15,6.14,17.91c0,0-41.32,38.88-70.76,39.13-46,.39-67.72-22.8-67.72-22.8Z",
    style: {
      fill: "#fbc05a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.67,1806.31s2,31.51,8.05,32c.81.06,30.92.06,30.92.06l38.43-.22s-.25-9.27-11.48-11.22-30-9.86-36.85-24.71C694.58,1786.56,672.67,1806.31,672.67,1806.31Z",
    style: {
      fill: "#113c68"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.45,1808.49s11.69,3.91,20.81,3.91a76.45,76.45,0,0,0,19.42-2.77s2.2-21.27,14.31-68.14c6.34-24.57,15.41-56.16,28.3-95.41,35.65-108.48,46.49-171.94,47.48-177.95.06-.31.08-.47.08-.47l-.12-.05-109.6-48.13s13.54,149.51-3.74,206.9a242,242,0,0,0-6.27,27.49C670.2,1716.2,670.45,1808.49,670.45,1808.49Z",
    style: {
      fill: "#15345b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725,1741.49c6.34-24.57,15.41-56.16,28.3-95.41,35.65-108.48,46.49-171.94,47.48-177.95,0-.18,0-.35,0-.52l-109.6-48.13s13.54,149.51-3.74,206.9C685,1634.4,725,1741.49,725,1741.49Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.28,1806.31s2,31.51,8.05,32c.81.06,30.92.06,30.92.06l38.43-.22s-.25-9.27-11.49-11.22-30-9.86-36.84-24.71C780.19,1786.56,758.28,1806.31,758.28,1806.31Z",
    style: {
      fill: "#15447c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.42,1423s1.42,96.89-15.34,215.84S794,1808.29,794,1808.29s-11.52,3.73-16.17,4.11c-11.84,1-24-2.77-24-2.77s-24-119-17.11-178.54-32.86-204.31-32.86-204.31Z",
    style: {
      fill: "#15345b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.7,1196.29l21.39,14,19.49-5.51c3.56-5.08,4.51-14.88,4.56-23.36a146.72,146.72,0,0,0-.76-15.56l-28.87-12.74-10.77-4.75c0,.17.84,8.85,1,10.11C750.7,1181,742.7,1196.29,742.7,1196.29Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.91,1449.94c-26.63,25.71-127.41,21.39-133.63-6.94s6.78-241.16,52.27-254.53c9.44-2.77,59.9,13.54,59.9,13.54a320.56,320.56,0,0,1,13.12,47.09c1,5.14,3.95,59.52,6.15,110.4,1,23.8,1.89,46.83,2.34,63.7C821.46,1439,821.48,1449.38,820.91,1449.94Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.85,1158.9c5.86,9.9,26.4,18.57,37.29,22.54a146.72,146.72,0,0,0-.76-15.56l-28.87-12.74C752.13,1153.05,748.24,1154.48,750.85,1158.9Z",
    style: {
      fill: "#fca56b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.26,1164.12s-46.51,14.51-55.1-14.59-20.37-46.83,9-57.33,38.4-1.1,43.63,7.92S810.14,1159.6,798.26,1164.12Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.93,1097.32s-3,33.86-10,32.39-14.71-4.61-13.69,5.6S763.46,1163,753.36,1163c-21.66-.09-45.19-55.67-39.26-66.2C731.21,1066.36,818.66,1060.22,793.93,1097.32Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.09,1189.21c-.6-.25-34.63-15.52-38.61-14.2s-8.93,13.46-8.93,13.46l59.9,13.55S794.74,1192.43,787.09,1189.21Z",
    style: {
      fill: "#fbc05a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.9,1354,808.18,1533.6c-3.74,3.52-8.45,4.64-10.47,2.49l-6.44-6.84c-2-2.15-.62-6.78,3.12-10.3l190.72-179.57c3.74-3.52,8.45-4.64,10.47-2.49l6.44,6.83C1004,1345.87,1002.64,1350.51,998.9,1354Z",
    style: {
      fill: "#1f4d84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.87,1454.8l-83.69,78.8c-3.74,3.52-8.45,4.64-10.47,2.49l-6.44-6.84c-2-2.15-.62-6.78,3.12-10.3l83.69-78.8Z",
    style: {
      fill: "#739af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.07,1286.23A149.49,149.49,0,1,0,1202.84,1136c-.77-.77-1.55-1.52-2.35-2.26a149.49,149.49,0,0,0-245.42,152.48Zm42.72-138a137.69,137.69,0,1,1,5.93,194.63A137.54,137.54,0,0,1,997.79,1148.27Z",
    style: {
      fill: "#1f4d84"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1198.35,1337a137.7,137.7,0,1,1-5.94-194.63A137.25,137.25,0,0,1,1198.35,1337Z",
    style: {
      fill: "#b3cff9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M821.06,1423.2c-105.09-74.88-96.35-174.81-96.35-174.81,38.41,21.66,76.52,69.56,94,111.11C819.74,1383.3,820.61,1406.33,821.06,1423.2Z",
    style: {
      fill: "#fbc05a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.78,1389.1c7.41-1.71,12.38-7.31,13.42-8.29,0,0,3.16.21-.52,7-.31.57-1,2-1.51,3a.66.66,0,0,0,.55.94c4.28.33,8.58-1.37,16.82.35,1.13.24,1.47,3,1.42,4.12a10.49,10.49,0,0,1-2.21,7.18c-1.33,1.75-5,3.64-13.28,6.95-3.14,1.27-12.13.32-20.55-2.58l-6.73-3.11,2.09-12.51,1.69.36C918.65,1393.06,922,1389.78,924.78,1389.1Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.32,1202s-94.42,18,27.78,154.72c19.55,21.87,125.14,50.34,125.14,50.34s10.71-9.11,5.31-16.49c0,0-72.7-52.8-88.7-61.19-7.2-3.78-27.93-84.27-39.66-103.65S757.32,1202,757.32,1202Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.31,1253s3.09-5.9,3.69-9,4.49-12.2,6.1-13.8c.64-.64,2.75.19,3,2.94.11,1.2-.48,3.38-1.52,6-1.68,4.22-1.41,9.95-2,11.86C947.12,1255.75,939.31,1253,939.31,1253Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.89,1018.74a5.7,5.7,0,0,0-1,6.09l0,0c1.46,4.06,6.32,8.59,12,13.12.72.58,1.37,1.11,1.92,1.6.15.13.3.26.43.39l.34.3c5.25,4.85,3.27,6,12.72,15.8,10.76,11.21,18.18,11.41,20.29,10.39,1.79-.87-1.84-6.81-5.85-13.49l-.59-1-1.6-2.68c-4.7-8-3.49-11.82-2.37-23.78.91-9.73,15.14-54.32,15.14-54.32l-20.64-3.57s-6.22,35.52-13.08,41c-3.66,2.92-7.76,3-11.28,5.11-.25.15-.49.31-.73.47A27,27,0,0,0,976.89,1018.74Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.89,1018.74a5.7,5.7,0,0,0-1,6.09l0,0c1.79,4.05,6.52,8.57,12,13.08.72.59,1.34,1.14,1.9,1.64.15.13.3.26.43.39l.34.3c5.25,4.85,3.27,6,12.72,15.8,10.76,11.21,18.18,11.41,20.29,10.39,1.79-.87-1.84-6.81-5.85-13.49a45.88,45.88,0,0,1-19.2-14.16c-6.25-8-10.49-18.14-14.74-24.39l-1.21-.22A27,27,0,0,0,976.89,1018.74Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.34,1005.91c1.27,6.37,10.36,5.31,20.5,2.84s7.74.47,22.18-1.13,18.82-7,19.26-9.12c.4-1.91-6.74-2.58-14.39-3.47-1-.1-1.93-.22-2.9-.34-8.64-1.09-15-6.67-22.81-11.25-7.44-4.34-18.53-22-18.53-22l-19.8,1.56s10.38,15.79,14.4,22.66c2.36,4,2.24,9.37,1.94,13.49A25.68,25.68,0,0,0,1143.34,1005.91Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.84,1008.75c10.15-2.48,7.74.47,22.18-1.13s18.82-7,19.26-9.12c.4-1.91-6.74-2.58-14.39-3.47l-.07.15a40.72,40.72,0,0,1-20.69,6.42c-9.8.24-20.17-2.57-26.94-2.47a25.68,25.68,0,0,0,.15,6.78C1144.61,1012.28,1153.7,1011.22,1163.84,1008.75Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.48,879.24,1049,929.05l-24.19,65.05a39.15,39.15,0,0,1-12.84-1.18c-5.79-1.67-12.42-6-12.42-6s6.73-69.84,19.27-109.93c3.21-10.3,6.81-18.62,10.78-23.3C1049,830.7,1067.48,879.24,1067.48,879.24Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.69,800.11c-10.54-3.4-38-.06-67.87,5.32A20.22,20.22,0,0,1,959.93,796h0l-75.06-5.88S860.08,845,873.63,880c2,5.15,6.37,8.36,13.12,8.47h0s45.36.08,59.86.08c37.33,0,79-25.63,84.41-26.71,8.82-1.76,12.35,15.89,21.16,34.42s82.92,82.09,82.92,82.09,11.39.12,16.1-1.64c5.06-1.9,6.91-4.36,6.91-4.36S1076,808.94,1048.69,800.11Z",
    style: {
      fill: "#2a4e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952,575.56a26.53,26.53,0,0,0-14.33-3.73,41.22,41.22,0,0,1-6.93-.42c-28.64-4.21-45.91,37.39-46.92,50-1.87,23.08-14.08,26.6-31.27,41-34.48,29-24.39,62.66-5.54,75.18,11.3,7.52,31.23,0,31.23,0,.29.2,54.52-30.29,81.26-45C999.6,686.94,968.13,585.15,952,575.56Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.13,680.08c.12.08-13.15,4.61-22,.67-8.34-3.69-14.66-17.42-14.54-17.43,3.8-.18,8-3.49,11.19-25.28l1.62.59,27.18,9.79s-2,8.72-3.25,17C936.22,672.42,935.64,679.1,937.13,680.08Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.55,648.42s-1.09,4.7-2.67,13.5c-15.62-2.82-22.32-14.85-24.51-23.29Z",
    style: {
      fill: "#ed975d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.59,657.08s-37.19-5-33.72-28.12,1-39.33,24.91-37.11,27.17,11.73,27.89,19.73S954.36,657.78,944.59,657.08Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.32,598.9s-23.82,20.52-40,22.16S900,617.51,900,617.51a63.11,63.11,0,0,0,15.29-20.71,11.4,11.4,0,0,1,9.4-6.71C936.23,589.1,958.15,588.65,962.32,598.9Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.43,597.06s8,7.71,10.47,13.42c2.42,5.51,3.14,18.7,1.21,23.93,0,0,12.42-24.12,5.4-35.85C957.06,586.12,947.43,597.06,947.43,597.06Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.43,734.89c-1.15,75.29-.33,59.55-8.57,66.7-2,1.72-7.56,2.74-14.9,3.22-23.09,1.53-63.68-2.29-65.22-6.56-5.32-14.76-1.56-19.35-6-42-.46-2.41-1-5-1.71-7.84-3.7-15.53-7.3-20.81,5.85-45.74,11.93-22.59,24.31-40.92,25.43-40.26,31.43,18.68,34,3,34,3S969,698.16,968.43,734.89Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049,929.05l-24.19,65.05a39.15,39.15,0,0,1-12.84-1.18c-5.79-1.67-12.42-6-12.42-6s6.73-69.84,19.27-109.93Z",
    style: {
      fill: "#2a4e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.3,665.44s32.35,5.5,36.15,19.43,16.27,98.49,16.27,98.49-9.13,8.91-16.72,1.31-23.89-79.12-23.89-79.12Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945,804.81c-23.09,1.53-63.68-2.29-65.22-6.56-5.32-14.76-1.56-19.35-6-42L884.89,725s-1.85,34.91,8.45,44.1,42.15,17.74,47.15,25.42A28.15,28.15,0,0,1,945,804.81Z",
    style: {
      fill: "#fbc05a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.51,790.12s22.78-5.07,26.45-3,12.65,9.38,13.78,11.94-8.18-1.94-11.21-2.76c-2-.52-7.12,1.27-9.68,2.12-10.75,3.58-17.33,1.73-17.33,1.73Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.3,662.44s-30.59,1.88-41.18,16.64c-14.91,20.78-44.5,109.36-27.56,121.18,19.07,13.31,86.84,3.51,86.84,3.51s2.26-10.54-.88-15.64-54.12-13.35-56.47-15.71,29.43-45.87,29.43-52.93S903.3,662.44,903.3,662.44Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.06,793.42s4.77,6.15,6.34,6.89a4.7,4.7,0,0,0,2.57.55l-3.21-5.79Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945,787.08l13.87,6.74a2.48,2.48,0,0,1-2.29.89,33.13,33.13,0,0,1-6-1.66Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1063.44 802.96 918.5 802.91 918.5 806.11 1062.15 806.15 1063.44 802.96",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "952.39 806.12 1062.15 806.15 1095.2 724.06 985.61 724.02 952.39 806.12",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.46,765.09c.83-2.88-.84-5.22-3.73-5.22a7.47,7.47,0,0,0-6.72,5.22c-.83,2.89.84,5.23,3.72,5.23A7.49,7.49,0,0,0,1034.46,765.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.27,1115.74c-14.78-4.91-25,1.28-25,1.28-42.57,1.75-44.15,45.39-39.15,61.63,7,22.81-17.82,40.79,9.72,50,32,10.71,58.78-2,57,3.52C1880.84,1240.16,1810.9,1126.9,1777.27,1115.74Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.12,1328a112,112,0,0,1-11.38,17.21c-8.85,11.08-55.26-15.21-51.27-17.21s27.33-69.2,32.88-77.64,24.48-12.83,24.48-12.83Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.76,1781.18s12.81,11.69,10.31,20-14.06,13.85-15.62,24-7.82,15.69-13.44,15.69h-26.82s-4.14-7.14,5.86-9.3,13.77-14.08,13.15-25.16.93-25.84.93-25.84l21.25-4.92Z",
    style: {
      fill: "#1f447f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.32,1786.15s4.61,49.53-1,52.3l-72-.15s0-8.31,11.56-10.15,31.87-8.62,35.31-23.7S1781.32,1786.15,1781.32,1786.15Z",
    style: {
      fill: "#1c3154"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.69,1294.57a284.73,284.73,0,0,1,0,33.27c-.71,12-12.88,28.14-14.6,32.12-4.34,10-9.22,11.63-9.22,11.63l-37.79,9.26-13.29,3.25-41.91-12.51s-19.08-53.28-11.42-83.27,19.37-50.81,19.37-50.81,28.48-6.4,78.72-2.84Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.29,1328.26c-.71,12-16.48,27.72-18.2,31.7-4.34,10-9.22,11.63-9.22,11.63l-37.79,9.26-6.83-19.56s55.22-14.5,46.34-65.61Z",
    style: {
      fill: "#fbc05a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.55,1379.67s-20.75,64.6-22.09,86.59,39.67,312.42,41.32,322.55c1.56,9.56,13.42,15.64,13.42,15.64a17.93,17.93,0,0,0,13.24,1c10.8-3,14.22-6.7,14.22-6.7s16.15-207.13,6.15-281.12a1172.93,1172.93,0,0,1-10.11-138Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.47,1377.75s31.66,42.47,34.61,71.18,4.63,129.57,10.92,157.56,29.38,81.85,29.38,169.16c0,0-2.4,5-9.81,7.66a79.85,79.85,0,0,1-8.63,2.39,13.57,13.57,0,0,1-15.18-7.2c-15.62-31.45-65.37-132.86-67.92-153.91-1.8-14.9-17.51-113.5-51.77-171.36-8.23-13.89,5-69.13,5-69.13Z",
    style: {
      fill: "#2a4e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.23,1369.7s8.33,6.59,24.88,6.93c19.77.39,68.76-5,68.76-5a40.76,40.76,0,0,1,2.09,12.5s-59.83,15.09-94.5,2.2C1720.46,1386.29,1716,1377.88,1719.23,1369.7Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.37,1393.66c-5,0-9-4.58-9-10.21s4.05-10.21,9-10.21,9,4.58,9,10.21S1744.35,1393.66,1739.37,1393.66Zm0-17.43c-3.32,0-6,3.24-6,7.22s2.71,7.22,6,7.22,6-3.24,6-7.22S1742.7,1376.23,1739.37,1376.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1782.59 1412.23 1692.67 1413.07 1648.43 1309.09 1738.35 1308.25 1782.59 1412.23",
    style: {
      fill: "#6769d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.83,1365.24l-6.59-8.1s-4.46-4-7.7-4.65-10.07-4.62-10.73-3.51,5.25,9,5.25,9l.3,0c-6.79,5.1-23.93.6-26,2.68-2.57,2.52,3.53,8,6.8,11s12.62,8.17,19.91,5.9c5.32-1.66,13.71-3.35,13.71-3.35Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.19,1327.38s5.65-6.42,9.25-3.34-.94,18.24-4.37,16.7S1653.22,1329.26,1655.19,1327.38Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.55,1234.67s25.74,2.84,44.22,36.4c14.56,26.47,39.47,75.26,30.07,89-4.13,6.05-43.67,27.58-119.94,15.27,0,0,1.2-9.63,7.35-14.1,0,0,64.19-20.6,64.08-24.7-.21-7.76-8.67-14.46-44.53-50.32C1778.05,1276.51,1806.55,1234.67,1806.55,1234.67Z",
    style: {
      fill: "#fccb78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.74,1236c.89-1.19-.25-5-1.67-12-1.28-6.38-3.45-16.25-3.4-27.35l-1.9.32-31.9,5.37s.72,8.53.74,16.56a1.41,1.41,0,0,1,0,.2c0,7-1.89,17.53.47,18.91C1761.17,1245.11,1783.34,1240.6,1786.74,1236Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.87,1202.36s.63,12,.65,20.06c17.86-.43,27.38-17.76,31.25-25.43Z",
    style: {
      fill: "#e8945b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.94,1216.7s41.82-6,37.71-31.94-1.48-44.26-28.35-41.56-30.49,13.44-31.23,22.45S1735,1217.58,1745.94,1216.7Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736.2,1145.59s16.27,28.67,34.52,30.38,25.1-4.19,25.1-4.19a50.27,50.27,0,0,1-20.91-26.74S1742.5,1129.71,1736.2,1145.59Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.42,1147.62s-8,4.51-10.46,11.24a42.5,42.5,0,0,0-1.84,24.76s-11.91-19.35-4.11-32.61C1731.29,1136.94,1739.42,1147.62,1739.42,1147.62Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.62,
    y: 1837.14,
    width: 2324.14,
    height: 7.47,
    rx: 2.9,
    style: {
      fill: "#233862"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBigIWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "big-i-warning.6c8248a.svg";